import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class PaymentService {
    private payDtSubject: BehaviorSubject<any>;
    public payData$: Observable<any>;

    constructor(
        private router: Router,
        private http: HttpClient
    ) {
        this.payDtSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('payInfo')));
        this.payData$ = this.payDtSubject.asObservable();
    }

    public get payInfo(): any {
        return this.payDtSubject.value;
    }
    
    setPaymentInfo(payInfo)
    {
        sessionStorage.setItem('payInfo', JSON.stringify(payInfo));
        this.payDtSubject.next(payInfo);
    }

    getMerchantInfo() {
    return this.http.get<any>(`${environment.apiUrl}payments/merchantinfo`);
    }

    getPaymentCompleteOrders(mobile:any){
        return this.http.get<any>(`${environment.apiUrl}payments/getPaymentCompleteOrders/`+mobile);
    }

    createMerchentOrder(orderDetails: any) {
        return this.http.post(
        `${environment.apiUrl}payments/payment_createorder`,
        orderDetails
        );
    }

    updateMerchentOrder(response: any) {
        return this.http.post(
        `${environment.apiUrl}payments/payment_success`,
        response
        );
    }
    
 
   
}